export default __webpack_public_path__ + "static/media/step-1.344c8f0e.png";